// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/:app_group_id/canvas/:workflow_id/step/:step_id" endpoint
 */
import { reactQueryFetcherAdapter } from "@dashboardApi/apis/reactQueryFetcherAdapters";

import fetch from "@lib/fetch";

import type { CanvasStepDocument } from "../../common";
import { engagementCanvasStep } from "./constants";

export const getCanvasStep = reactQueryFetcherAdapter(
  engagementCanvasStep,
  (
    signal: AbortSignal,
    appGroupId: string,
    workflowId: string,
    stepId: string,
    postLaunchDraft = false,
    summaryOnly = false
  ): Promise<CanvasStepDocument> => {
    return fetch(
      `/${appGroupId}/canvas/${workflowId}/step/${stepId}`,
      "GET",
      { post_launch_draft: postLaunchDraft, summary_only: summaryOnly },
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
